<div class="modal-header py-2">
  <h2 class="mb-0">You have marked this date as {{ closedType }} on a secondary schedule. This does not affect your primary schedule.</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="ok()"></tr-icon>
</div>
<div class="modal-footer">
  <button class="btn btn-info mr-2" type="submit" (click)="ok(true)">OK</button>
</div>
